// extracted by mini-css-extract-plugin
module.exports = {"button":"StyledButton_button__IGc2z","icon":"StyledButton_icon__b8zSX","text":"StyledButton_text__3465O"};